import React from "react";
import { makeStyles } from "@mui/styles";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const SimpleDatepicker = (props) => {
  // Define styles
  const useStyles = makeStyles(() => ({
    datePicker: {
      width: props.CustomWidth ? props.CustomWidth : "100%", // Set width to 100% of parent container
      "& .MuiIconButton-root": {
        // Target the IconButton inside the DatePicker
        color: "#171717",
        "border-radius": "50%",
        background: "#F7F6F7",
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        // Change border color when focused
        borderColor: "#FB4764",
      },
    },
  }));

  const handleDateChange = (date) => {
    if (date) {
      let NewDate = dayjs(date).format("YYYY-MM-DD");
      props.SaveNewDate(NewDate);
    }
  };

  const classes = useStyles(); // Initialize styles

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        {/* Apply custom styles to DatePicker */}
        <DatePicker
          label={props.Label}
          disabled={props.Disabled}
          className={classes.datePicker}
          value={props.DefaultValue ? dayjs(props.DefaultValue) : null}
          onChange={handleDateChange}
          maxDate={props.MaxDate ? props.MaxDate : undefined}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default SimpleDatepicker;
